<template>
    <div class="shop-tile global-material-tile">
        <div class="row">
            <div class="col-3 col-md-4 col-lg-3">
                <div class="tile--image-wrapper" style="position:relative;">
                    <component :is="tile.detail_link ? 'a' : 'span'" class="tile--link" :href="tile.detail_link" @click="onLinkClick">
                        <img class="tile--image img-fluid" :title="tile.title" :src="tile.image_src" :alt="tile.title">
                    </component>
                    <slot name="button-add2wishlist"></slot>
                </div>
            </div>
            <div class="col-9 col-md-8 col-lg-9 tile-content-wrapper">
                <div class="tile-content">
                    <component :is="tile.detail_link ? 'a' : 'span'" class="tile--link" :href="tile.detail_link" @click="onLinkClick">
						<p class="tile--title"><strong>{{ tile.title }}</strong></p>
                        <p class="tile--subtitle">{{ tile.subtitle }}</p>
                        <p class="tile--subtitle">{{ tile.subsubtitle }}</p>
                    </component>
                </div>
                <slot name="button-area"></slot>
                <slot name="remove-button"></slot>
				<div class="button-wrapper spacer--top-small" v-if="$slots.ordercount">
                    <slot name="ordercount"></slot>
				</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "shop-tile",
        props: {
            tile: Object
        },
        methods: {
            onLinkClick: function() {
                if (this.tile.detail_link) {
                    window.promised_gtag.then((gtag) => {
                        gtag('event', 'Download', {
                            'event_category': this.tile.subtype === 'karte' ? 'collection' : this.tile.subtype,
                            'event_label': this.tile.pim_id
                        });
                    });
                }
            }
        }
    }
</script>
